import { checkLogin, LoginResult } from 'JIX/utils/login.js';

async function showLoginBox(event) {
    event.preventDefault();
    const res = await checkLogin();
    if (res === LoginResult.LOGGED_IN || res === LoginResult.ALREADY_LOGGED_IN) {
        this.submit();
    }
}

document.querySelectorAll('.cvinfo-create-form').forEach(form => {
    form.addEventListener('submit', showLoginBox);
});
